import React, { useState, useEffect } from 'react';
import 'chartjs-plugin-annotation';
import { Line } from 'react-chartjs-2';

import { EmptyDataWrapper } from '../EmptyWrapper';
import { useLabTestHistoryContext } from '../state/context';
import { LabTestHistoryLegend } from '../LabTestHistoryLegend';
import {
  setConfig,
  shouldShowGraph,
} from '../utils/graphData';

import styles from './index.styl';

export const LabTestHistoryGraph = () => {
  const [localData, setLocalData] = useState([]);
  const [shouldRenderGraph, setShouldRenderGraph] = useState(false);
  const { data, pending, formatMessage } = useLabTestHistoryContext();

  useEffect(() => {
    setLocalData(data);
    setShouldRenderGraph(() => shouldShowGraph(data));
  }, [pending, data]);

  const props = {
    ...setConfig({ localData, shouldRender: shouldRenderGraph }),
  };

  return (
    <div className={styles.wrapper}>
      {shouldRenderGraph && (
        <EmptyDataWrapper
          pending={pending}
          isDataEmpty={localData.length === 0}
          formatMessage={formatMessage}
        >
          <Line {...props} />
          <LabTestHistoryLegend />
        </EmptyDataWrapper>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryGraph/index.jsx